import * as React from 'react';
import Add from './Add';
import Panel from './Panel';
import PlayerLogin from './PlayerLogin';
import {LoginProps, ServerState, LeaderboardEntry, GameLobbyState} from './AppTypes';
import {ActiveGames} from './ActiveGames';
import {GameLobbies} from './GameLobbies';
import {StartGame} from './StartGame';
import {Leaderboard} from './Leaderboard';
import {GameModeName} from './common/modes/GameMode';

interface ServerLobbyProps {
    login: LoginProps;
    server?: ServerState;
    topPlayers?: LeaderboardEntry[];
    onSetName: (name: string) => void;
    onSetGameMode: (modeName: GameModeName) => void;
    onSelectMap: (mapName: string) => void;
    onStartGame: () => void;
    onJoinGame: (lobby: GameLobbyState) => void;
}

export function ServerLobby({
    login,
    server,
    topPlayers,
    onSetName,
    onSetGameMode,
    onSelectMap,
    onStartGame,
    onJoinGame,
}: ServerLobbyProps): JSX.Element {
    if (!server) {
        return <div>Loading...</div>;
    }
    return (
        <div>
            <header className="App-header">
                <h1 className="App-title">Mortar Blast!</h1>
            </header>
            <div className="App-panels">
                <Panel id="ad-panel">
                    <Add />
                </Panel>
                <Panel id="name-panel">
                    <PlayerLogin name={login.name} onSetName={onSetName} />
                </Panel>
                <Leaderboard topPlayers={topPlayers || []} />
                <div className="line-break" />
                <StartGame
                    modeName={login.modeName}
                    mapName={login.mapName}
                    maps={server.maps}
                    onSetGameMode={onSetGameMode}
                    onSelectMap={onSelectMap}
                    onStart={onStartGame}
                />
                <GameLobbies lobbies={server.lobbies || []} onJoinGame={onJoinGame} />
                <ActiveGames games={server.games || []} />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/ServerLobby.tsx